import type { WebModul } from '../../core/modul';
import { Symbol } from '../../core/symbole';
import { Hinweis } from './Hinweis';
import { Karte } from './Karte';
import { Seite } from './Seite';
import { Startkarte } from './Startkarte';

const aufgaben: WebModul = {
  id: 'aufgaben',
  name: 'Aufgaben',
  reihenfolge: 20,
  symbol: Symbol.aufgaben,
  Seite,
  Karte,
  Startkarte,
  UeberallGlobal: Hinweis,
};
export default aufgaben;
